import { itemInitOptions } from '../config/config.js'
import { EQ, LT, LE, NOT_EQ, NOT_NULL, NULL, GT, GE, BETWEEN, NOT_BETWEEN } from '@/assets/js/config/condition-config'

export function getNps(item1, row) {
  let str = ''
  if (row.items) {
    row.items.map((item, index) => {
      if (item.value.indexOf("(") != -1) {
        if (row.questionType == 9 || row.questionType == 21 || row.questionType == 15 || row.questionType == 16 || row.questionType == 10) {
          str = '(' + item.value.split('(')[1]
        }
      } else {
        const labels = row.questionDetails.issue.labels
        const [a1, a2] = [labels[0].text, labels[labels.length - 1].text]
        str = '(' + [a1, a2].join('-') + ')'
      }
    })
    return item1.num + str
  } else {
    return str
  }
}

export function updateNewData(val, row, id = 0) {
  row.items[id].value = val
  // let existId = this.updateArr.findIndex(it => it.questonId === row.questonId);
  // if (existId === -1) {
  //   this.updateArr.push(row);
  // }
  this.saveArr();
}

export function getImg(item) {
  var answerArr = ''
  if (item && item.content && item.content.image && item.content.image[0]) {
    answerArr = this._getDownloadUrl(item.content.image[0].url)
  }
  return answerArr
}
// 矩阵填空题 input事件
export function changeMatrixInput(val, rowItem, col) {
  const matchAnswer = this.rowData.items.find(item => {
    return item.colId === col.id && item.rowId === rowItem.row_id
  })
  if (matchAnswer) {
    matchAnswer.value = val
  } else {
    this.rowData.items.push(Object.assign({}, itemInitOptions, {
      colId: col.id,
      rowId: rowItem.row_id,
      value: val
    }))
  }
  // let ids = this.updateArr.indexOf(this.rowData)
  // if (ids === -1) {
  //   this.updateArr.push(this.rowData)
  // }
  this.saveArr();
}
// 校验
export function checkOtherVal(val, item) {
  let reg;
  let errorText;
  let middleText;
  let isLengthError;
  let pre = item.validate == 'num' ? '的' : '个';
  let typeCount = item.validate == 'num' ? parseInt(val) : val.length;
  let minLength = item.minLength && parseInt(item.minLength);
  let maxLength = item.maxLength && parseInt(item.maxLength);
  if (minLength && maxLength && minLength >= 0 && maxLength >= 0) {
    isLengthError = typeCount >= minLength && typeCount <= maxLength;
    middleText = minLength + '-' + maxLength + pre;
  } else if (minLength && minLength >= 0 && (maxLength == -1 || !maxLength)) {
    isLengthError = typeCount >= minLength;
    middleText = minLength + '及' + minLength + '以上' + pre;
  } else if (maxLength && maxLength >= 0 && (minLength == -1 || !minLength)) {
    isLengthError = typeCount <= maxLength;
    middleText = maxLength + '及' + maxLength + '以下' + pre;

  } else {
    isLengthError = true;
    middleText = ''
  }
  switch (item.validate) {
    case 'char': reg = /^[A-Za-z]+$/; errorText = '请输入' + middleText + '字母'; break;
    case 'num': reg = /^[0-9]+$/; errorText = '请输入' + middleText + '数字'; break;
    case 'chinese': reg = /^[\u4e00-\u9fa5]+$/; errorText = '请输入' + middleText + '汉字'; break;
    case 'phone': reg = /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9]))\d{8}$/; errorText = '请输入正确手机号'; break;
    case 'email': reg = /^[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]@[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$/; errorText = '请输入正确电子邮箱'; break;
    default: reg = ''; errorText = '请输入' + middleText + '字符';
  }
  this.errorText = errorText;
  let isError = reg ? !(reg.test(val) && isLengthError) : !isLengthError;
  return isError
};
//保存
export function saveArr(rowData = this.rowData) {
  const existIdx = this.updateArr.findIndex((item) => {
    return item.questonId === rowData.questonId && item.groupQuestionKey === rowData.groupQuestionKey
  })
  if (existIdx === -1) { //添加
    this.updateArr.push(rowData)
  }
  return existIdx

};

export function getDisabled() {
  let appendItems = [];
  let indexs = this.allQuesionList.indexOf(this.rowData);
  this.allQuesionList.slice(indexs + 1, this.allQuesionList.length).forEach(item => {
    if (item?.questionDetails?.issue?.append_items?.length) {
      appendItems.push(...item.questionDetails.issue.append_items.map(it => it.from_qid))
    }
  })
  appendItems = Array.from(new Set(appendItems));
  // let idArr = this.connectItems.map(itt=>itt.optionId);
  if (appendItems.includes(this.rowData.questonId)) {
    return true;
  } else {
    return false;
  }
}

const conditions = {
  [EQ]: '等于',
  [NOT_EQ]: '不等于',
  [GT]: '大于',
  [GE]: '大于等于',
  [LT]: '小于',
  [LE]: '小于等于',
  [BETWEEN]: '介于（含等于）',
  [NOT_BETWEEN]: '不介于',
  [NULL]: '为空',
  [NOT_NULL]: '不为空'
}
export function getConditionText(v) {
  return conditions[v]
}